import axios from "axios";
import { message } from "antd";
import { getRequester, getToken } from "./Common";

const BASE_URL = process.env.REACT_APP_LINK;
const API_KEY = process.env.REACT_APP_API_KEY;
const token = getToken();
const requester = getRequester();

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Handle 401 error (unauthorized)
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      message.error("Session expired. Logging out now...");
      setTimeout(() => {
        window.location.href = "/"; // Redirect to the login page after 1 second
      }, 1000);
    }
    return Promise.reject(error);
  }
);

// export const encryptPayload = (data: any) => {
//   const dataString = JSON.stringify(data)
//   const secretKey = CryptoJS.enc.Utf8.parse("0123456789abcdef")
//   const iv = CryptoJS.enc.Utf8.parse("abcdef9876543210")
//   const encryptedPayload = CryptoJS.AES.encrypt(dataString, secretKey, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   }).toString()
//   return encryptedPayload
// }

// export const decryptData = (encryptedData) => {
//   const secretKey = CryptoJS.enc.Utf8.parse("1l0v3yoVvirUs$es")
//   const iv = CryptoJS.enc.Utf8.parse("abcdef9876543210")

//   const decryptedData = CryptoJS.AES.decrypt(encryptedData, secretKey, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   })

//   const decryptedString = decryptedData.toString(CryptoJS.enc.Utf8)

//   return JSON.parse(decryptedString)
// }

// export const decryptData = (encryptedData) => {
//   const secretKey = CryptoJS.enc.Utf8.parse("1l0v3yoVvirUs$es"); // 16-byte key

//   // Base64 decode the encrypted data to get the IV and encrypted string
//   const decodedData = CryptoJS.enc.Base64.parse(encryptedData).toString(
//     CryptoJS.enc.Hex
//   );

//   // Extract the IV from the decoded data (first 32 hex characters = 16 bytes)
//   const iv = CryptoJS.enc.Hex.parse(decodedData.substring(0, 32));

//   // Extract the actual encrypted part (the remaining hex string after the IV)
//   const encryptedPart = CryptoJS.enc.Hex.parse(decodedData.substring(32));

//   // Perform decryption using the key and IV
//   const decrypted = CryptoJS.AES.decrypt(
//     { ciphertext: encryptedPart },
//     secretKey,
//     { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
//   );

//   // Return the decrypted data as a UTF-8 string
//   return decrypted.toString(CryptoJS.enc.Utf8);
// };

export const postRequest = async (
  apiName: string,
  data = {},
  isFormData = false
) => {
  const url = `${BASE_URL}/${apiName}`;

  let headers: any = {
    "API-KEY": API_KEY,
  };

  let payload: any;

  if (isFormData && data instanceof FormData) {
    // Append token and requester to FormData
    data.append("token", token || '');
    data.append("requester", requester || '');

    // Send FormData directly
    payload = data;
    // Do NOT set Content-Type manually; Axios will set it to multipart/form-data automatically
  } else {
    // Normal JSON request
    headers["Content-Type"] = "application/json";
    payload = {
      token: token,
      requester: requester,
      ...data,
    };
  }
  // const encryptedPayload = encryptPayload(payload);

  try {
    const response = await axios.post(
      url,
      // { signature: encryptedPayload },
      payload,
      { headers }
    );
    return { data: response.data, success: true };
  } catch (error) {
    return { data: error, success: false };
  }
};

export const postRequestV2 = async (
  apiName: string,
  data = {},
  isFormData = false
) => {
  const url = `${BASE_URL}${apiName}`;

  const headers = {
    "Content-Type": isFormData ? "multipart/form-data" : "application/json",
    "API-KEY": API_KEY,
  };
  const payload = {
    ...data,
    token: token,
    requester: requester,
  };

  try {
    const response = await axios.post(url, payload, { headers });
    return { data: response, success: true };
  } catch (error) {
    return { error: error, success: false };
  }
};

// Get request function
export const getRequest = async (
  apiName: string,
  params = {},
  isFormData = false
) => {
  const url = `${BASE_URL}/${apiName}`;
  const headers = {
    "Content-Type": "application/json",
    "API-KEY": API_KEY,
  };
  const payload = {
    ...params,
    token: token,
    requester: requester,
  };

  try {
    const response = await axios.get(url, {
      params: payload,
      headers: headers,
    });
    return { data: response.data, success: true };
  } catch (error) {
    return { error: error, success: false };
  }
};
